import PropTypes from 'prop-types';
import { EventCalendarEvents } from 'components/EventCalendarPage/EventCalendarEvents/EventCalendarEvents';
import { EventFiltersProvider } from 'components/Shared/EventFiltersProvider';
import { EventCalendarFiltersContainer } from './EventCalendarFiltersContainer';

import './EventCalendarPage.scss';

export const EventCalendarPage = (props) => (
  <EventFiltersProvider {...props} itemsPerPage={7} pageType={1}>
    <EventCalendarFiltersContainer {...props} />
    <EventCalendarEvents />
  </EventFiltersProvider>
);

export const EventCalendarPageSC = (props) => {
  const { sitecoreData } = props;
  return <EventCalendarPage {...sitecoreData} />;
};

EventCalendarPageSC.propTypes = {
  sitecoreData: PropTypes.object,
};

EventCalendarPage.propTypes = {
  FilterSet: PropTypes.array,
  GenreId: PropTypes.string,
  FiltersActive: PropTypes.bool,
  SortByActive: PropTypes.bool,
};
